import { type ReactNode } from "react";

/**
 * Route content wrapper. Intentionally a no-op — do NOT set key={pathname}.
 * Third-party DOM mutators (Perfectus/Cognos, GHL tracker, CallRail swap)
 * rewrite text nodes React is tracking, and a forced remount on every
 * navigation makes React crash with "Cannot read properties of null
 * (reading 'removeChild')". TanStack Router already remounts route
 * components on match change; this wrapper just passes children through.
 */
export function PageTransition({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
